export default __webpack_public_path__ + "static/media/news-thumb5.684f6fb2.png";